<template>
  <div class="page-box" v-loading="loading">
    <!-- <template v-if="isFirst"> -->
      <div> 
        <Step :list="list" :active="active" />
      </div>

      <div class="page-main"> 
        <Upload v-if="active == 1" />
        <List v-if="active == 2" />
        <Done v-if="active == 3 "/>
      </div>
    <!-- </template> -->
  </div>

</template>

<script setup>
import { ref, provide } from 'vue';
import {useRouter, useRoute}from 'vue-router'
import Step from './step'
import List from './list'
import Upload from './upload'
import Done from './done'
import Log from './log'
import {importGroupRecord} from '@/api/interfaceList'
import Cookies from 'js-cookie'

const router = useRouter();
const route = useRoute();
const active = ref(1);
const list = ['上传导入文件', '确认导入文件', '导入成功'];
const loading = ref(true);

const isFirst = ref(true);
const importBatchNo = ref('');
const setActive = () => {
  active.value += 1;
}

importGroupRecord({
  userCode: JSON.parse(Cookies.get("userInformation")).userCode,
  page: 1,
  row: 1,
}).then(res => {
  if(res.code == 1 && res?.data?.total > 0){
    if(!route.query.type){
      isFirst.value = false;
      router.push('/copyrightExportLog')
    }
  }
}).catch(e => {
  console.log(e,'e')
}).finally(() => {
  loading.value = false
})
const setImportBatchNo = (val) => {
  importBatchNo.value = val
}

provide('cExport', {
  setActive,
  setImportBatchNo,
  importBatchNo,
  isFirst
})

</script>
<style scoped>

.page-box{
  background: #fff;
  border-radius: 10px;
  padding: 10px;
}

.page-main{
  padding: 10px;
}
</style>
